import React from "react";

const Schema = (props) => {
  let start = props.page * 10 - 9;
  let end = props.page * 10 + 1;
  if (props.page === 1) {
    start = 0;
    end = 10;
  }
  var schemaArray = props.reviewData.slice(start, end).filter(function (value) {
    return value.sourceType !== "Direct Feedback";
  });
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
              "@context": "http://schema.org",
              "@type": "${props.businessType}",
              "name": "${props.aggregateData.name}",
              "image": "${props.aggregateData.logoUrl}",
              "priceRange": "$$",
              "telephone": "${props.aggregateData.phone}",
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "${props.aggregateData.avgRating}",
                "reviewCount": "${props.aggregateData.reviewCount}"
              },
              "address" :{
                "@type": "PostalAddress",
                "streetAddress": "1001 E Pipeline Rd",
                "addressLocality": "Bedford",
                "addressRegion": "TX",
                "postalCode": "76022",
                "addressCountry": "US"
              },
              "review": [
              ${
                props.reviewData &&
                schemaArray
                  .map((review, i, arr) => {
                    return `
                      {
                        "@type": "Review",
                        "author": {
                          "@type": "Person",
                          "name": "${review.reviewer.nickName}"
                        },
                        "datePublished": "${review.reviewDate}",
                        "description": "${
                          review.comments == null
                            ? ""
                            : review.comments
                                .replace(/(\r\n|\n|\r)/gm, "")
                                .replace(/"/gm, "'")
                        }",
                        "name": "${review.title == null ? "" : review.title}",
                        "reviewRating": {
                          "@type": "Rating",
                          "bestRating": "5",
                          "ratingValue": "${review.rating}",
                          "worstRating": "1"
                        }
                      } ${arr.length - 1 !== i ? `,` : ""}
                  `;
                  })
                  .join("")
              }
              
          ]
        }`,
      }}
    />
  );
};

export default Schema;
